export enum VehicleCapacityType {
  Legacy = 'legacy',
  VehicleType = 'vehicleType',
}
